/**
 * boost-search-ui.js
 * Enhances Boost AI search product cards:
 * - Injects custom.product_badges metafield badge
 * - Formats Yotpo review count to (N) format
 * - Autofocus search input on search trigger click
 * - Removes duplicate X clear icon
 */

(function () {
  var badgeCache = {}; // handle → badge text or null
  var primaryImageCache = {}; // handle → metafield image attributes
  var productRequests = {};

  function fetchProduct(handle) {
    if (!productRequests[handle]) {
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      productRequests[handle] = fetch(root + 'products/' + encodeURIComponent(handle) + '.js')
        .then(function (response) { return response.ok ? response.json() : null; })
        .catch(function (error) { delete productRequests[handle]; throw error; });
    }
    return productRequests[handle];
  }

  function searchProductLink(item) {
    var link = item.querySelector('a[href*="/products/"]');
    var match = link && (link.getAttribute('href') || '').match(/\/products\/([^?#/]+)/);
    return match ? { handle: match[1], url: new URL(link.getAttribute('href'), window.location.origin) } : null;
  }

  function searchVariant(product, variantId) {
    var variants = product.variants || [];
    return variants.find(function (variant) { return String(variant.id) === variantId; })
      || variants.find(function (variant) { return variant.available; })
      || variants[0];
  }

  function applyVariantPrices(item, product) {
    var link = searchProductLink(item);
    var container = item.querySelector('.boost-sd__suggestion-queries-item-price');
    if (!link || link.handle !== product.handle || !container) return;
    var variant = searchVariant(product, link.url.searchParams.get('variant'));
    if (!variant) return;
    var price = Number(variant.price);
    var compare = Number(variant.compare_at_price) || 0;
    var signature = [product.handle, variant.id, price, compare].join(':');
    var saleElement = container.querySelector('[data-bk-variant-price]');
    if (container.dataset.bkVariantSignature === signature && saleElement) return;
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'CAD';
    var formatter = new Intl.NumberFormat(document.documentElement.lang || 'en', {
      style: 'currency', currency: currency, currencyDisplay: 'narrowSymbol'
    });
    var amount = document.createElement('span');
    amount.className = 'boost-sd__suggestion-queries-item-amount' + (compare > price ? ' boost-sd__suggestion-queries-item-amount--sale' : '');
    var sale = document.createElement('span');
    sale.className = 'boost-sd__format-currency boost-sd__format-currency--price-sale';
    sale.dataset.bkPriceCents = String(price);
    sale.dataset.bkVariantPrice = String(variant.id);
    var saleText = document.createElement('span');
    saleText.textContent = formatter.format(price / 100);
    saleText.setAttribute('aria-label', 'Sale price: ' + saleText.textContent);
    sale.appendChild(saleText);
    amount.appendChild(sale);
    if (compare > price) {
      var original = document.createElement('span');
      original.className = 'boost-sd__format-currency boost-sd__format-currency--price-compare';
      original.dataset.bkPriceCents = String(compare);
      original.dataset.bkVariantPrice = String(variant.id);
      var originalText = document.createElement('span');
      originalText.textContent = formatter.format(compare / 100);
      originalText.setAttribute('aria-label', 'Compare price: ' + originalText.textContent);
      original.appendChild(originalText);
      amount.appendChild(original);
    }
    container.replaceChildren(amount);
    container.dataset.bkVariantSignature = signature;
    container.dataset.bkPricingHandle = product.handle;
    stripCurrencyCode(item);
    formatDiscount(item);
  }

  function syncVariantPrices(item) {
    var link = searchProductLink(item);
    if (!link || !item.querySelector('.boost-sd__suggestion-queries-item-price')) return;
    fetchProduct(link.handle).then(function (product) {
      if (product && item.isConnected) applyVariantPrices(item, product);
    }).catch(function () {});
  }

  // ── Fetch custom.product_badges via section render ─────────────────────────
  function fetchBadge(handle) {
    if (badgeCache[handle] !== undefined) {
      return Promise.resolve(badgeCache[handle]);
    }
    return fetch('/products/' + handle + '?section_id=boost-product-badge')
      .then(function (r) { return r.ok ? r.text() : null; })
      .then(function (html) {
        if (!html) { badgeCache[handle] = null; return null; }
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var el = doc.querySelector('.bk-badge-data');
        if (!el) { badgeCache[handle] = null; return null; }
        primaryImageCache[handle] = {
          src: el.getAttribute('data-primary-image'),
          srcset: el.getAttribute('data-primary-image-srcset')
        };
        try {
          var badges = JSON.parse(el.getAttribute('data-badges') || 'null');
          var badge = Array.isArray(badges) && badges.length ? badges[0] : (badges || null);
          badgeCache[handle] = badge;
          return badge;
        } catch (e) {
          badgeCache[handle] = null;
          return null;
        }
      })
      .catch(function () { badgeCache[handle] = null; return null; });
  }

  var pendingImageFetches = {};

  function syncPrimaryImage(item) {
    var link = item.querySelector('a[href*="/products/"]');
    var match = link && (link.getAttribute('href') || '').match(/\/products\/([^?#/]+)/);
    var handle = match && match[1];
    if (!handle) return;
    if (primaryImageCache[handle] !== undefined) {
      applyPrimaryImage(item, handle);
      return;
    }
    if (pendingImageFetches[handle]) return;
    pendingImageFetches[handle] = true;
    fetchBadge(handle).then(function () {
      delete pendingImageFetches[handle];
      document.querySelectorAll('.boost-sd__suggestion-queries-item--product').forEach(function (card) {
        var cardLink = card.querySelector('a[href*="/products/"]');
        var cardMatch = cardLink && (cardLink.getAttribute('href') || '').match(/\/products\/([^?#/]+)/);
        if (cardMatch && cardMatch[1] === handle) applyPrimaryImage(card, handle);
      });
    });
  }

  function applyPrimaryImage(item, handle) {
    var data = primaryImageCache[handle];
    var image = item.querySelector('.boost-sd__suggestion-queries-item-img');
    if (!data || !data.src || !image) return;
    if (image.getAttribute('src') !== data.src) image.setAttribute('src', data.src);
    if (image.getAttribute('srcset') !== data.srcset) image.setAttribute('srcset', data.srcset);
  }

  // ── Enhance a single product card item ────────────────────────────────────
  function enhanceItem(item) {
    if (item.dataset.bkEnhanced) {
      syncVariantPrices(item);
      syncPrimaryImage(item);
      return;
    }
    item.dataset.bkEnhanced = 'true';

    // Format reviews immediately and watch for async Yotpo render
    // stripCurrencyCode runs once after availability fetch — NOT inside observer
    formatReviews(item);
    formatDiscount(item);
    new MutationObserver(function () {
      formatReviews(item);
      formatDiscount(item);
      syncVariantPrices(item);
      syncPrimaryImage(item);
    }).observe(item, { childList: true, subtree: true, attributes: true, attributeFilter: ['src', 'srcset', 'href'] });

    var link = item.querySelector('a[href*="/products/"]');
    var match = link && (link.getAttribute('href') || '').match(/\/products\/([^?#/]+)/);
    var handle = match && match[1];
    if (!handle) return;

    // Remove Boost's default Sale badge
    item.querySelectorAll('.boost-sd__suggestion-queries-item-badge--sale, .boost-sd__suggestion-queries-item-badge--sold-out').forEach(function (el) {
      el.remove();
    });

    // Hide until availability confirmed, then animate in
    item.style.opacity = '0';
    item.style.transform = 'translateY(-5px)';
    item.style.transition = 'opacity 0.1s ease-in, transform 0.1s ease-in';
    fetchProduct(handle)
      .then(function (p) {
        if (!p || !p.available) {
          item.style.setProperty('display', 'none', 'important');
        } else {
          applyVariantPrices(item, p);
          stripCurrencyCode(item);
          item.style.opacity = '1';
          item.style.transform = 'translateY(0)';
        }
      })
      .catch(function () {
        stripCurrencyCode(item);
        item.style.opacity = '1';
        item.style.transform = 'translateY(0)';
      });

    // Apply immediately if cached, otherwise fetch
    function applyBadge(badgeText) {
      if (!badgeText) return;
      var leftPanel = item.querySelector('.boost-sd__suggestion-queries-item-product--left');
      if (!leftPanel) return;
      var existing = leftPanel.querySelector('.boost-sd__suggestion-queries-item-badge span');
      if (existing) {
        existing.textContent = badgeText;
      } else {
        var badge = document.createElement('div');
        badge.className = 'boost-sd__suggestion-queries-item-badge bk-custom-badge';
        badge.innerHTML = '<span>' + badgeText + '</span>';
        leftPanel.insertBefore(badge, leftPanel.firstChild);
      }
    }

    if (badgeCache[handle] !== undefined) {
      // Already fetched — apply synchronously
      applyBadge(badgeCache[handle]);
      applyPrimaryImage(item, handle);
    } else {
      fetchBadge(handle).then(function (badgeText) {
        // Re-query all items with this handle in case Boost re-rendered
        document.querySelectorAll('.boost-sd__suggestion-queries-item--product').forEach(function (el) {
          var elLink = el.querySelector('a[href*="/products/' + handle + '"]');
          if (!elLink) return;
          applyPrimaryImage(el, handle);
          var leftPanel = el.querySelector('.boost-sd__suggestion-queries-item-product--left');
          if (!leftPanel || !badgeText) return;
          var existing = leftPanel.querySelector('.boost-sd__suggestion-queries-item-badge span');
          if (existing) {
            existing.textContent = badgeText;
          } else {
            var badge = document.createElement('div');
            badge.className = 'boost-sd__suggestion-queries-item-badge bk-custom-badge';
            badge.innerHTML = '<span>' + badgeText + '</span>';
            leftPanel.insertBefore(badge, leftPanel.firstChild);
          }
        });
      });
    }
  }

  function formatDiscount(item) {
    var sale = item.querySelector('.boost-sd__format-currency--price-sale');
    var compare = item.querySelector('.boost-sd__format-currency--price-compare');
    var badge = item.querySelector('[data-bk-discount]');
    var container = item.querySelector('.boost-sd__suggestion-queries-item-price');
    var link = searchProductLink(item);
    var sameVariant = sale && compare && sale.dataset.bkVariantPrice
      && sale.dataset.bkVariantPrice === compare.dataset.bkVariantPrice
      && container && link && container.dataset.bkPricingHandle === link.handle;
    var price = sameVariant ? Number(sale.dataset.bkPriceCents) : NaN;
    var comparePrice = sameVariant ? Number(compare.dataset.bkPriceCents) : NaN;
    var percentage = comparePrice > 0 ? (comparePrice - price) * 100 / comparePrice : 0;
    if (!sale || !compare || !Number.isFinite(percentage) || percentage <= 10) {
      if (badge) badge.remove();
      return;
    }
    if (!badge) {
      badge = document.createElement('span');
      badge.className = 'price-discount-percentage';
      badge.dataset.bkDiscount = 'true';
      badge.dataset.bkPriceFormatted = 'true';
      compare.after(badge);
    }
    var label = '−' + Math.round(percentage) + '%';
    if (badge.textContent !== label) badge.textContent = label;
  }

  function stripCurrencyCode(item) {
    item.querySelectorAll('.boost-sd__suggestion-queries-item-amount span, .boost-sd__format-currency span').forEach(function (el) {
      if (el.dataset.bkPriceFormatted || el.children.length > 0) return;
      if (el.closest('.bk-price-symbol, .bk-price-integer, .bk-price-decimal')) return;
      // Compare-at price — strip currency and add .00 if whole number
      if (el.closest('.boost-sd__format-currency--price-compare')) {
        el.dataset.bkPriceFormatted = 'true';
        var compareText = el.textContent.replace(/\s*(CAD|USD|EUR|GBP|AUD)\s*/g, '').trim();
        if (compareText && !compareText.includes('.')) compareText += '.00';
        el.textContent = compareText;
        return;
      }
      el.dataset.bkPriceFormatted = 'true';

      var text = el.textContent.replace(/\s*(CAD|USD|EUR|GBP|AUD)\s*/g, '').trim();
      if (!text) return;

      // Split on actual decimal point only
      var match = text.match(/^([^0-9]*)([0-9]+)(?:\.([0-9]*))?$/);
      if (!match) { el.textContent = text; return; }

      var symbol = match[1] || '$';
      var integer = match[2];
      var decimal = match[3]; // only set if a '.' was present
      if (decimal === undefined || decimal === '') decimal = '00';
      if (decimal === '0') decimal = '00';
      if (decimal.length === 1) decimal = decimal + '0';

      // Amazon-style: symbol and decimal sit at top, integer is large
      el.innerHTML =
        '<span class="bk-price-symbol">' + symbol + '</span>' +
        '<span class="bk-price-integer">' + integer + '</span>' +
        '<span class="bk-price-decimal">' + decimal + '</span>';
      el.style.display = 'inline-flex';
      el.style.alignItems = 'flex-start';
      el.style.lineHeight = '1';
    });
  }

  function formatReviews(item) {
    item.querySelectorAll('.yotpo-sr-bottom-line-text--right-panel').forEach(function (el) {
      if (el.dataset.bkFormatted) return;
      var num = el.textContent.replace(/[^0-9]/g, '');
      if (!num) return;
      el.dataset.bkFormatted = 'true';
      el.textContent = '(' + num + ')';
    });
    // Hide score number and vertical border
    item.querySelectorAll('.yotpo-sr-bottom-line-score, .yotpo-sr-vertical-border').forEach(function (el) {
      el.style.display = 'none';
    });

  }

  // ── Observe for Boost rendering product items ──────────────────────────────
  function init() {
    // Enhance already-present items
    document.querySelectorAll('.boost-sd__suggestion-queries-item--product').forEach(enhanceItem);

    // Watch for new items added by Boost
    new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (n) {
          if (n.nodeType !== 1) return;
          if (n.classList && n.classList.contains('boost-sd__suggestion-queries-item--product')) {
            enhanceItem(n);
          }
          if (n.querySelectorAll) {
            n.querySelectorAll('.boost-sd__suggestion-queries-item--product').forEach(enhanceItem);
          }
        });
      });
    }).observe(document.body, { childList: true, subtree: true });

    // ── Mobile: set CSS var for header bottom + scroll lock ─────────────────────
    function setMobileHeaderOffset() {
      var headerColumns = document.querySelector('.header__columns.spacing-style.page-width');
      if (!headerColumns) return;
      var bottom = headerColumns.getBoundingClientRect().bottom;
      document.documentElement.style.setProperty('--bk-mobile-header-bottom', bottom + 'px');
    }
    setMobileHeaderOffset();
    window.addEventListener('resize', setMobileHeaderOffset);

    // Lock body scroll when search open
    new MutationObserver(function () {
      var isOpen = document.body.classList.contains('boost-sd__g-no-scroll');
      document.body.style.setProperty('overflow', isOpen ? 'hidden' : '', 'important');
      if (isOpen) setMobileHeaderOffset();
    }).observe(document.body, { attributes: true, attributeFilter: ['class'] });

    // ── Autofocus on search trigger click ────────────────────────────────────
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('.search-action');
      if (!trigger) return;
      var attempts = 0;
      function tryFocus() {
        var wrapper = document.querySelector('.boost-sd__search-bar-wrapper--desktop:not(.boost-sd__g-hide)');
        var input = wrapper && wrapper.querySelector('.boost-sd__search-bar-input');
        if (!input) {
          // Mobile fallback
          var mWrapper = document.querySelector('.boost-sd__search-bar-wrapper--mobile:not(.boost-sd__g-hide)');
          input = mWrapper && mWrapper.querySelector('.boost-sd__search-bar-input');
        }
        if (input && input.offsetParent !== null) {
          input.focus();
        } else if (attempts++ < 15) {
          setTimeout(tryFocus, 80);
        }
      }
      setTimeout(tryFocus, 80);
    });

    // ── Clear input when search closes ────────────────────────────────────
    new MutationObserver(function () {
      var isOpen = document.body.classList.contains('boost-sd__g-no-scroll');
      if (!isOpen) {
        setTimeout(function () {
          document.querySelectorAll('.boost-sd__search-bar-input').forEach(function (input) {
            if (!input.value) return;
            // Use native value setter to bypass React/Vue tracking
            var nativeInputSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value').set;
            nativeInputSetter.call(input, '');
            input.dispatchEvent(new Event('input', { bubbles: true }));
            input.dispatchEvent(new Event('change', { bubbles: true }));
          });
        }, 50);
      }
    }).observe(document.body, { attributes: true, attributeFilter: ['class'] });

    // ── Remove duplicate X clear icon ──────────────────────────────────────
    new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (n) {
          if (n.nodeType !== 1) return;
          var clears = Array.from(n.querySelectorAll
            ? n.querySelectorAll('[data-group="clear-search-form"], .boost-sd__search-bar-clear')
            : []);
          if (n.matches && (n.matches('[data-group="clear-search-form"]') || n.matches('.boost-sd__search-bar-clear'))) {
            clears.push(n);
          }
          clears.forEach(function (el) {
            el.style.setProperty('display', 'none', 'important');
          });
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
